import React from "react";
import { View, Text, TextInput, StyleSheet } from "react-native";
import { scale, verticalScale } from "../../utils/scale";

export class CustomTextInput extends React.Component {
  render() {
    return (
      <View style={[styles.mainContainer, this.props.containerStyle]}>
        <Text style={[styles.titleStyle, this.props.titleStyle]}>
          {this.props.title}
        </Text>
        <View
          style={[
            styles.textInputContainer,
            this.props.textInputContainerStyle,
          ]}
        >
          <TextInput
            placeholderTextColor="rgba(0, 0, 0, 0.36)"
            style={[styles.textInputStyle, this.props.textInputStyle]}
            {...this.props}
          />
        </View>
      </View>
    );
  }
}
const styles = StyleSheet.create({
  mainContainer: { width: "100%", marginTop: verticalScale(20) },
  titleStyle: {
    fontSize: scale(14),
    width: scale(330),
    alignSelf: "center",
    height: verticalScale(20),
    lineHeight: 22,
    marginLeft: scale(5),
  },
  textInputContainer: {
    width: scale(330),
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: scale(4),
    height: verticalScale(50),
    marginVertical: verticalScale(5),
    alignSelf: "center",
    justifyContent: "center",
  },
  textInputStyle: { marginLeft: scale(15), color: "black" },
});
